import CalculateRepairCost from './CalculateRepairCost';
import { setTransactionAmount } from '../actions';

export default function calculateTotalBudgetAmount() {
  return async (dispatch, getState) => {
    const {
      collect: { chosenModality, modalities },
      device: { selectedDefects },
    } = getState().NewRepairReducer;

    const transactionAmount = await CalculateRepairCost(
      selectedDefects,
      chosenModality,
      modalities,
    );
    if (!transactionAmount) return Promise.reject();
    dispatch(setTransactionAmount(transactionAmount));

    return Promise.resolve(transactionAmount);
  };
}
